const Noticia = ({ taulesReis, premis }) => {
	return (
		<div id="taula_reis">
			{taulesReis.map(({ title, key, blocks }) => (
				<div className="taula" key={key}>
					<div className="titol">
						<div className="l1">{title}</div>
					</div>
					{blocks.map((block, i) => (
						<div key={i}>
							<div className="l5">{block.label(premis[key])}</div>
							<div className="l3">{block.prize}</div>
						</div>
					))}
				</div>
			))}
		</div>
	)
}
export default Noticia
